import { createSelector } from 'reselect'
import { createSelector as ormCreateSelector } from 'redux-orm'
import orm from '../../models/models'

export const favorites = state =>
  state.orm.Favorite ? state.orm.Favorite.items : {}

export const getFavorites = createSelector(
  state => state.orm,
  state => state.ui.favorites.orderInfo,
  favorites,
  ormCreateSelector(orm, (session, order) => {
    let favorites = session.Favorite.all()

    if (
      !order ||
      Object.keys(order).length === 0 ||
      order.direction === 'DEFAULT'
    ) {
      favorites = favorites.orderBy('orderby')
    } else {
      // This code is here to maintain order of entries when they are sorted and a user undos a removal
      let orderByFns = []
      switch (order.order) {
        case 'title':
          orderByFns.push(favorite => {
            const planEntry = session.PlanEntry.withId(favorite.planEntry)
            return planEntry.title
          })
          break
        case 'coach':
          const orderFirstNameFn = favorite => {
            const planEntry = session.PlanEntry.withId(favorite.planEntry)
            const firstCoach = planEntry.planProduct.coaches[0]
            return firstCoach.firstName
          }

          const orderLastNameFn = favorite => {
            const planEntry = session.PlanEntry.withId(favorite.planEntry)
            const firstCoach = planEntry.planProduct.coaches[0]
            return firstCoach.lastName
          }

          orderByFns = [orderFirstNameFn, orderLastNameFn]
          break
        case 'plan':
          orderByFns.push(favorite => {
            const planEntry = session.PlanEntry.withId(favorite.planEntry)
            return planEntry.planProduct.title
          })
          break
        case 'duration':
          orderByFns.push(favorite => {
            const planEntry = session.PlanEntry.withId(favorite.planEntry)
            return planEntry.durationInMs
          })
          break
        case 'date':
          orderByFns.push(favorite => {
            return favorite.createdAt
          })
          break
      }

      let isAscendingOrder = order.direction === 'ASC'

      if (order.order === 'date') {
        isAscendingOrder = !isAscendingOrder
      }

      const direction = isAscendingOrder ? 'asc' : 'desc'

      favorites = favorites.orderBy(orderByFns, direction)
    }
    return favorites
  })
)

export const isFavorite = (state, planEntryId) => {
  const selector = createSelector(
    state => state.orm,
    favorites,
    ormCreateSelector(orm, session => {
      return session.Favorite.filter(
        favorite => favorite.planEntry === planEntryId
      ).exists()
    })
  )
  return selector(state)
}
